const PROJECT_NAME = '天一龙纺织科技OMS'; //项目名称
export const PROJECT_CODE = 'tyl'; //项目code
export const PROJECT_PORT = 'oms'; //端

export const C_PROJECT_NAME = PROJECT_NAME; //项目名称
export const C_SESSION = 'session'; //session

/**
 * 技术支持
 * @type {{NAME: string, PATH: string}}
 */
export const C_AUTHOR = {
  TIME: `${new Date().getFullYear()}`,
  NAME: '天一龙纺织科技有限公司',
  PATH: 'https://www.bjpygh.com',
};

/**
 * API请求路径
 * @type {{HOST: string, PATH: string}}
 */
export const C_API = {
  HOST_PATH: '/api', // 基本请求路径/debug/code/api，线上debug是空，
  TIMEOUT: 15000, //api请求超时时间
};

export const C_PATTERN = {
  idNumber:
    /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, // 身份证号码
  phone: /^1[345678]\d{9}$/, //手机
  tel: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, //座机电话
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!\W+$)[A-Za-z0-9\W]{6,18}$/, // 密码
  price:
    /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, // 价格，精确两位小数
  nonNegativeInteger: /^(0|[1-9][0-9]*)$/, //非负整数
  integer: /^[1-9][0-9]*$/, //正整数
  email: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, // 邮箱
  url: /^(?:(?:(?:(?:https?|ftp|bjpygh):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$)|(^pages\/.*$)/, // url格式
};

/**
 * 网络请求后端返回状态吗
 * @type {{OK: number, ERR_401: number, ERR_404: number, ERR_UNKNOWN: number}}
 */
export const C_RESP = {
  OK: 200,
  ERR_401: 401,
  ERR_404: 404,
};

/**
 * 存入storage缓存
 * @type {{SESSION: string, KEY_USER: string}}
 */
export const C_STORAGE = {
  TOKEN: `${process.env.PRODUCTION_ENV}_${PROJECT_CODE}_${PROJECT_PORT}_token`,
  AUTH: `${process.env.PRODUCTION_ENV}_${PROJECT_CODE}_${PROJECT_PORT}_auth`, //登录信息，存下来内容是个对象
  INFO: `${process.env.PRODUCTION_ENV}_${PROJECT_CODE}_${PROJECT_PORT}_info`, //账户信息，存下来内容是个对象
  USERNAME: `${process.env.PRODUCTION_ENV}_${PROJECT_CODE}_${PROJECT_PORT}_username`, //登录账号
  PASSWORD: `${process.env.PRODUCTION_ENV}_${PROJECT_CODE}_${PROJECT_PORT}_password`, //登录密码
};

export const C_ICON = [
  'icon-file-copy',
  'icon-gift',
  'icon-bell',
  'icon-menu',
  'icon-qq',
  'icon-search',
  'icon-money',
  'icon-spa',
  'icon-listnested',
  'icon-icskill',
  'icon-component',
  'icon-clipboard',
  'icon-dashboard',
  'icon-github',
  'icon-list',
  'icon-radio',
  'icon-eye-open',
  'icon-shouye',
  'icon-color',
  'icon-question',
  'icon-select',
  'icon-fullscreen',
  'icon-form',
  'icon-icon-test',
  'icon-chart',
  'icon-jiankong',
  'icon-email',
  'icon-language',
  'icon-tab',
  'icon-clouddownload',
  'icon-theme',
  'icon-bug',
  'icon-wechat',
  'icon-icon',
  'icon-message',
  'icon-eye',
  'icon-input',
  'icon-international',
  'icon-nested',
  'icon-size',
  'icon-textarea',
  'icon-build',
  'icon-redis',
  'icon-time',
  'icon-phone',
  'icon-edit',
  'icon-user',
  'icon-grid',
  'icon-pdf',
  'icon-drag',
  'icon-example',
  'icon-guide',
  'icon-zip',
  'icon-Lock',
  'icon-date',
  'icon-slider',
  'icon-tree',
  'icon-link',
  'icon-documentation',
  'icon-shopping',
  'icon-people',
  'icon-tree-table',
  'icon-swagger',
  'icon-password',
  'icon-switch',
  'icon-validCode',
  'icon-online',
  'icon-checkbox',
  'icon-cloudupload',
  'icon-education',
  'icon-date-range',
  'icon-rate',
  'icon-system',
  'icon-execl',
  'icon-button',
  'icon-peoples',
  'icon-cascader',
  'icon-row',
  'icon-logininfor',
  'icon-dict',
  'icon-post',
  'icon-number',
  'icon-time-range',
  'icon-job',
  'icon-exit-fullscreen',
  'icon-tool',
  'icon-druid',
  'icon-redis-list',
  'icon-server',
  'icon-code',
  'icon-log',
  'icon-star',
];

export const C_COLOR = [
  'amber',
  'sky',
  'green',
  'pink',
  'emerald',
  'cyan',
  'fuchsia',
  'red',
  'violet',
  'blue',
  'indigo',
  'lime',
  'purple',
  'yellow',
  'orange',
  'rose',
  'gray',
  'teal',
];
